<template>
<div>
  <search-input alias="Vendedor" v-model="form.salesman_id.value" :displayedValue="form.name.value" :form="form" :name="'salesman_id'" @search="searchPerson($event)" :searchResult="searchPersonResults.results" :isLoading="searchPersonResults.isLoading" @selected="setPerson($event)">
    <search-input-option v-for="(row, index) in searchPersonResults.results.data" :key="index" :index="index" @click="setPerson(row)">
      <div>
        {{ row.name }}
        <br />
        <small class="text-muted">{{ row.cpf }}</small>
        <br />
      </div>
    </search-input-option>
  </search-input>
</div>
</template>

<script>
import Form from "./../mixins/Form.js";

export default {
  props: {
    value: {},
    name: {},
  },

  data: function () {
    return {
      form: new Form({
        salesman_id: {
          alias: "Vendedor",
          value: null
        },

        name: {},
      }),

      searchPersonResults: {
        results: {},
        isLoading: false
      },

    }
  },

  created() {
    this.form.salesman_id.value = this.value
    this.form.name.value = this.name
  },

  computed: {
    salesman_id() {
      return this.form.salesman_id.value
    }
  },

  watch: {
    salesman_id(newValue) {
      this.$emit('input', newValue)
    },

    value: function (newValue, oldValue) {
      this.form.salesman_id.value = newValue
    },

    name: function (newValue, oldValue) {
      this.form.name.value = newValue
    }

  },

  methods: {
    // search person for seachInput component\
    searchPerson(search) {
      this.searchPersonResults.isLoading = true;

      axios
        .post(process.env.BASE_URL + "api/salesman/select?page=" + search.page, {
          name: search.text,

        })
        .then(response => {
          this.searchPersonResults.results = response.data;

          this.searchPersonResults.isLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.error = error;
        });
    },

    setPerson(person) {
      this.selectedPerson = person;

      this.form.salesman_id.value = person.id;

      this.form.name.value = person.name;
      
      this.$emit('selected', this.selectedPerson)
    },
  }
};
</script>

<style>
</style>
